<template>
  <div class="list-container">
    <div class="notice">
      <div>
        ●
        每天早上8点统计商家因货期超期、主动断计划所产生的应赔付信息，并生成赔付单。
      </div>
      <div>
        ●
        每天早上10点，系统执行赔付脚本，将所有前一天生成的且状态为"待赔付"的赔付单执行资金划扣。
      </div>
    </div>

    <div class="table-wrapper">
      <el-table
        v-if="tableData.length > 0"
        ref="multipleTable"
        v-loading="loading"
        :data="tableData"
        max-height="800"
        style="width: 100%"
        :default-sort="{ prop: 'id', order: 'descending' }"
      >
        <el-table-column
          prop="id"
          label="赔付单ID"
          sortable
          width="120"
          align="center"
        />

        <el-table-column
          prop="type"
          label="赔付原因"
          width="120"
          align="center"
        >
          <template #default="scope">
            {{
              scope.row.type_text ||
              (scope.row.type === "1" ? "货期超时" : "缺货断货")
            }}
          </template>
        </el-table-column>

        <el-table-column
          prop="status"
          label="处理状态"
          width="120"
          align="center"
        >
          <template #default="scope">
            {{
              scope.row.status_text ||
              {
                "1": "待赔付",
                "2": "已完成",
                "3": "已作废",
              }[scope.row.status]
            }}
          </template>
        </el-table-column>

        <el-table-column
          prop="created_at"
          label="赔付单生成时间"
          width="180"
          align="center"
        />

        <el-table-column
          prop="complete_datetime"
          label="赔付单完成时间"
          min-width="180"
          align="center"
        />

        <el-table-column
          prop="supply_name"
          label="供应商(商家)"
          min-width="150"
          align="center"
        />

        <el-table-column
          prop="supply_id"
          label="商家ID"
          min-width="120"
          align="center"
        />

        <el-table-column
          prop="kh_num"
          label="款数"
          width="120"
          align="center"
        />

        <el-table-column
          prop="total_num"
          label="件数"
          width="120"
          align="center"
        />

        <el-table-column
          prop="total_slow_compensation_price"
          label="赔付金额"
          width="120"
          align="center"
        >
          <template #default="scope">
            {{
              scope.row.total_slow_compensation_price
                ? `¥${scope.row.total_slow_compensation_price}`
                : "-"
            }}
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="120" align="center">
          <template #default="scope">
            <el-button
              type="text"
              size="small"
              @click="handleDetail(scope.row)"
            >
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="data" class="pagination">
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <!-- 操作日志弹窗 -->
    <el-dialog title="操作日志" :visible.sync="logVisible">
      <el-table :data="logData">
        <el-table-column
          property="admin"
          label="操作人"
          align="center"
        ></el-table-column>
        <el-table-column
          property="operate_mode"
          label="操作方式"
          align="center"
        ></el-table-column>
        <el-table-column
          property="operate_result"
          label="操作结果"
          align="center"
        ></el-table-column>
        <el-table-column
          property="created_at"
          label="操作时间"
          align="center"
        ></el-table-column>
        <el-table-column
          property="remark"
          label="备注"
          align="center"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { logList } from "@/controller/refundBill.js";

export default {
  name: "CompensationList",

  props: {
    data: {
      type: Object,
      default: () => ({ list: [], total: 0 }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      logVisible: false,
      logData: [],
    };
  },

  computed: {
    tableData() {
      return this.data?.list || [];
    },
    total() {
      return this.data?.total || 0;
    },
  },

  methods: {
    handleDetail(row) {
      this.$emit("detail", row);
    },

    handleSizeChange(val) {
      this.$emit("size-change", val);
    },

    handleCurrentChange(val) {
      this.$emit("current-change", val);
    },

    async handleLogOpen(row) {
      try {
        this.logData = await logList({ srb_id: row.id });
        this.logVisible = true;
      } catch (error) {
        this.$message.error("获取日志失败");
      }
    },
  },
};
</script>

<style scoped>
.list-container {
  border: 1px solid #ddd;
}

.notice {
  background: #f3f3f3;
  height: 70px;
  line-height: 30px;
  padding: 0 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #f40000;
  font-size: 14px;
}

.table-wrapper {
  margin-bottom: 0;
}

.pagination {
  text-align: right;
  padding: 25px;
}

.el-table ::v-deep .cell {
  white-space: pre-line;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/pages/merchantClaimsOrder/components/CompensationList.vue